// Shared client UI primitives, reusable across all Mentora storefront apps.
export { AddressAutocomplete } from './lib/address/address-autocomplete'
export {
  type GAddressComponent,
  type GAutocompleteSuggestion,
  type GPlace,
  loadPlacesLibrary,
  type ParsedAddress,
  parsePlace,
  type PlacesLib,
} from './lib/address/google-places'
export { cn } from './lib/cn'
export {
  COUNTRY_CODES,
  type CountryCode,
  countryName,
  type CountryOption,
  isCountryCode,
} from './lib/country/countries'
export { CountryCombobox } from './lib/country/country-combobox'
export { useIsMobile } from './lib/hooks/use-mobile'
export { isValidPhone, PhoneInput } from './lib/phone/phone-input'

// shadcn/ui primitives (shared design system)
export * from './lib/ui/avatar'
export * from './lib/ui/badge'
export * from './lib/ui/button'
export * from './lib/ui/card'
export * from './lib/ui/chart'
export * from './lib/ui/dialog'
export * from './lib/ui/dropdown-menu'
export * from './lib/ui/info-hint'
export * from './lib/ui/input'
export * from './lib/ui/label'
export * from './lib/ui/progress'
export * from './lib/ui/select'
export * from './lib/ui/separator'
export * from './lib/ui/sheet'
export * from './lib/ui/sidebar'
export * from './lib/ui/skeleton'
export * from './lib/ui/switch'
export * from './lib/ui/tabs'
export * from './lib/ui/textarea'
export * from './lib/ui/tooltip'
